<script lang="ts">
  import { productsStore, filteredProducts, productCategories } from '../stores/products';
  import ProductCard from './ProductCard.svelte';
  import { onMount } from 'svelte';

  let searchQuery = $state('');

  onMount(() => {
    // Produkte beim Mount laden
    productsStore.load();
  });

  $effect(() => {
    productsStore.setSearchQuery(searchQuery);
  });
</script>

<div class="space-y-4">
  <!-- Search Bar -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
      <!-- Search Field -->
      <div class="md:col-span-2">
        <input
          type="text"
          bind:value={searchQuery}
          placeholder="Produkt suchen..."
          class="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-gray-900 bg-white placeholder:text-gray-400"
        />
      </div>
      <!-- Categories -->
      {#if $productCategories.length > 0}
        <div class="flex flex-wrap gap-1.5 items-center">
          <button
            onclick={() => productsStore.setCategory(null)}
            class="px-2 py-1 rounded-full text-xs text-gray-700 border border-gray-300 hover:bg-gray-50 bg-white whitespace-nowrap"
          >
            Alle
          </button>
          {#each $productCategories as category}
            <button
              onclick={() => productsStore.setCategory(category.id)}
              class="px-2 py-1 rounded-full text-xs text-gray-700 border border-gray-300 hover:bg-gray-50 bg-white whitespace-nowrap"
            >
              {category.name}
            </button>
          {/each}
        </div>
      {/if}
    </div>
  </div>

  <!-- Products Grid -->
  {#if $filteredProducts.length > 0}
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {#each $filteredProducts as product}
        <ProductCard {product} />
      {/each}
    </div>
  {:else}
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
      <p class="text-gray-600">
        {searchQuery ? 'Keine Produkte gefunden' : 'Keine Produkte verfügbar'}
      </p>
    </div>
  {/if}
</div>

